import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import LogoImage from "../images/logo.png"; // Replace with the path to your logo
// TEMPORARILY DISABLED: import useIframeAuth from "../hooks/useIframeAuth";

const ThankYouPage = () => {
  // TEMPORARILY DISABLED: const { isAuthorized, isChecking } = useIframeAuth();

  /* TEMPORARILY DISABLED: iframe auth check
  // Show loader while checking iframe auth
  if (isChecking) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="loader"></div>
      </Box>
    );
  }

  // If not authorized, component will redirect (handled by hook)
  if (!isAuthorized) {
    return null;
  }
  */

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        textAlign: "center",
        padding: 2,
      }}
    >
      <Box
        component="img"
        src={LogoImage}
        alt="Logo"
        sx={{
          width: 150,
          height: "auto",
          marginBottom: 3,
        }}
      />
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: "bold",
          color: "#333",
          marginBottom: 2,
        }}
      >
        Thank You!
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#555",
          marginBottom: 4,
        }}
      >
        Your submission has been received successfully.
      </Typography>
      {/* <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={goToHome}
        sx={{
          textTransform: "none",
        }}
      >
        Go Back to Home
      </Button> */}
    </Box>
  );
};

export default ThankYouPage;
